'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _MenuList = require('./MenuList');

var _MenuList2 = _interopRequireDefault(_MenuList);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WindowedSelect(props, ref) {
  var _props$windowThreshol = props.windowThreshold,
      windowThreshold = _props$windowThreshol === undefined ? 100 : _props$windowThreshol;

  var optionsLength = (0, _react.useMemo)(function () {
    return (0, _util.calcOptionsLength)(props.options);
  }, [props.options]);
  var isWindowed = optionsLength >= windowThreshold;

  return _react2.default.createElement(_reactSelect2.default, _extends({}, props, {
    components: _extends({}, props.components, isWindowed ? { MenuList: _MenuList2.default } : {}),
    ref: ref
  }));
}

exports.default = _react2.default.forwardRef(WindowedSelect);
module.exports = exports['default'];